import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function setAuthHeader(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("wl_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("wl_token");
  }
}

const saved = localStorage.getItem("wl_token");
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;
